export class PostDTO {
  constructor(
    public id: number,
    public link: string,
    public title: string,
    public categories: string[],
    public shortDescription: string,
    public cover: string | null,
  ) {}
}
